import { Offset, Placement } from '@lumapps/lumx/react';

export const MENU_OFFSET: Offset = { away: 8 };
export const PLACEMENT: Placement = Placement.BOTTOM_END;
